// GAVION ai-email (spec §6): « Brouillons à approuver (n) » on the dashboard, only when there is one.
import { Sparkles } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { usePendingDraftCount } from "./useAiDrafts";

export const DraftsToApproveCard = () => {
  const t = useTranslate();
  const n = usePendingDraftCount();
  if (n === 0) return null;
  return (
    <Link
      to="/brouillons"
      className="flex items-center gap-2 rounded-xl border bg-card px-4 py-3 text-sm font-medium hover:bg-accent"
    >
      <Sparkles className="size-4" aria-hidden="true" />
      {t("gavion.ai.drafts.dashboard", { smart_count: n })}
    </Link>
  );
};
